
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commercial-card-mastercard-offers",
      function () {
        return require("private-next-pages/commercial-card-mastercard-offers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commercial-card-mastercard-offers"])
      });
    }
  